const menu = {
    list() {
        return [{
            "backMenu": [],
            "frontMenu": [],
            "hasBackLogin": "否",
            "hasBackRegister": "否",
            "hasFrontLogin": "是",
            "hasFrontRegister": "是",
            "roleName": "用户",
            "tableName": "yonghu"
        }, {
            "backMenu": [],
            "frontMenu": [],
            "hasBackLogin": "否",
            "hasBackRegister": "否",
            "hasFrontLogin": "否",
            "hasFrontRegister": "否",
            "roleName": "摄影师",
            "tableName": "sheyingshi"
        }, {
            "backMenu": [{
                "child": [{
                    "allButtons": ["新增", "查看", "修改", "删除", "私聊"],
                    "appFrontIcon": "cuIcon-copy",
                    "buttons": ["新增", "查看", "修改", "删除"],
                    "menu": "用户管理",
                    "menuJump": "列表",
                    "tableName": "yonghu"
                }], "menu": "用户管理"
            }, {
                "child": [{
                    "allButtons": ["新增", "查看", "修改", "删除", "私聊"],
                    "appFrontIcon": "cuIcon-attentionfavor",
                    "buttons": ["新增", "查看", "查看评价","修改", "删除"],
                    "menu": "摄影师管理",
                    "menuJump": "列表",
                    "tableName": "sheyingshi"
                }], "menu": "摄影师管理"
            }, {
                "child": [{
                    "allButtons": ["新增", "查看", "修改", "删除"],
                    "appFrontIcon": "cuIcon-discover",
                    "buttons": ["新增", "查看", "修改", "删除"],
                    "menu": "作品分类",
                    "menuJump": "列表",
                    "tableName": "category"
                },{
                    "allButtons": ["新增", "查看", "修改", "删除", "查看评论", "删除评论"],
                    "appFrontIcon": "cuIcon-cardboard",
                    "buttons": [ "查看", "修改", "删除", "查看评论", "删除评论"],
                    "menu": "摄影作品",
                    "menuJump": "列表",
                    "tableName": "photographs"
                }], "menu": "摄影作品管理"
            },    {
                "child": [{
                    "allButtons": ["新增", "查看", "修改", "删除", "导出", "日销量", "月销量", "季销量", "年销量", "品销量", "类销量", "日销额", "月销额", "季销额", "年销额", "品销额", "类销额"],
                    "appFrontIcon": "cuIcon-pay",
                    "buttons": ["首页统计","查看", "修改", "删除", "发货","配送", "退货审核", "日销量", "月销量", "季销量", "年销量", "品销量", "类销量", "日销额", "月销额", "季销额", "年销额", "品销额", "类销额"],
                    "menu": "摄影预约管理",
                    "tableName": "orders"
                }], "menu": "摄影预约管理"
            },{
                "child": [{
                    "allButtons": ["新增", "查看", "修改", "删除"],
                    "appFrontIcon": "cuIcon-news",
                    "buttons":["新增", "查看", "修改", "删除"],
                    "menu": "公告资讯管理",
                    "tableName": "news"
                }], "menu": "公告资讯管理"
            }, {
                "child": [ {
                    "allButtons": ["新增", "查看", "修改", "删除"],
                    "appFrontIcon": "cuIcon-cardboard",
                    "buttons": ["查看", "修改"],
                    "menu": "轮播图管理",
                    "tableName": "config/1"
                }], "menu": "系统管理"
            }],
            "frontMenu": [],
            "hasBackLogin": "是",
            "hasBackRegister": "否",
            "hasFrontLogin": "否",
            "hasFrontRegister": "否",
            "roleName": "管理员",
            "tableName": "users"
        }]
    }
}
export default menu;
